import { render, staticRenderFns } from "./FarewellWishes.vue?vue&type=template&id=fd6efb14&scoped=true&"
import script from "./FarewellWishes.vue?vue&type=script&lang=js&"
export * from "./FarewellWishes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6efb14",
  null
  
)

export default component.exports